<div class="card">
  <div class="card-body">
    <!-- title -->
    <ng-container *ngIf="title">
      <h5 class="card-title">{{title}}</h5>
      <p-progressSpinner *ngIf="loading"></p-progressSpinner>
    </ng-container>
    <ng-container *ngIf="!title">
      <ng-content select=".card-title"></ng-content>
      <p-progressSpinner *ngIf="loading"></p-progressSpinner>
    </ng-container>

    <!-- main body -->
    <ng-content></ng-content>
  </div>
</div>
<div class="card-under-row">
  <ng-content select=".under-row"></ng-content>
</div>
